import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { getRequest } from 'utils/api';
import { closeModal } from 'features/utilsSlice';
import useModalOpen from 'hooks/useModalOpen';
import ProfileInDialog from './ProfileInDialog';
import TransitionDialog from 'components/TransitionDialog';
import FullScreenCircularLoader from 'components/FullScreenCircularLoader';

const useStyles = makeStyles(theme => ({
  paper: {
    height: '80%',
    marginTop: 'auto',

    [theme.breakpoints.up('md')]: {
      height: '100%',
    },
  },
}));

const ProfileDialog = ({
  acceptApplication,
  rejectApplication,
  handleDialogClose,
  handleInvite,
  isLoadingActions,
  hasActions,
  showCartIcon,
  fromMatches,
  hideInviteButton,
}) => {
  const [profile, setProfile] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const open = useModalOpen('Profile');
  const classes = useStyles();
  const username = useSelector(state => state.utils.modalData['Profile']?.username);

  const dispatch = useDispatch();

  const handleClose = () => dispatch(closeModal('Profile'));

  useEffect(() => {
    setIsLoading(true);
    if (!username) return;

    getRequest({
      endpoint: `profiles/${username}/public_profile`,
      query: { as_advertiser: true },
    })
      .then(response => {
        setProfile(response);
        setIsLoading(false);
      })
      .catch(() => setIsLoading(false));
  }, [username]);

  return (
    <TransitionDialog
      open={open}
      handleClose={handleClose}
      paperProps={{ className: classes.paper }}
      direction="up"
      desktopDirection="left"
      noCloseIcon
    >
      {isLoading ? (
        <FullScreenCircularLoader />
      ) : (
        <ProfileInDialog
          acceptApplication={acceptApplication}
          rejectApplication={rejectApplication}
          handleDialogClose={handleDialogClose}
          profile={profile}
          setProfile={setProfile}
          isLoadingActions={isLoadingActions}
          hasActions={hasActions}
          showCartIcon={showCartIcon}
          handleInvite={handleInvite}
          fromMatches={fromMatches}
          hideInviteButton={hideInviteButton}
        />
      )}
    </TransitionDialog>
  );
};

ProfileDialog.propTypes = {
  acceptApplication: PropTypes.func,
  rejectApplication: PropTypes.func,
  handleDialogClose: PropTypes.func,
  isLoadingActions: PropTypes.object,
  hasActions: PropTypes.bool,
  showCartIcon: PropTypes.bool,
  handleInvite: PropTypes.func,
  hideInviteButton: PropTypes.bool,
  fromMatches: PropTypes.bool,
};

ProfileDialog.defaultProps = {
  acceptApplication: () => {},
  rejectApplication: () => {},
  handleDialogClose: () => {},
  isLoadingActions: {},
  hasActions: false,
  showCartIcon: false,
  hideInviteButton: false,
  handleInvite: () => {},
  fromMatches: false,
};

export default ProfileDialog;
